import { type ComponentRef, Directive, input, output, type Type } from '@angular/core';
import { outputFromObservable, outputToObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import { takeUntil } from 'rxjs/operators';
import { type Board } from '../../types/board';
import { BoardContextMenuComponent } from './board-context-menu/board-context-menu.component';

/** Signal inputs and outputs throughout; `ngOnInit` stays because `ContextMenuDirective` configures the popover
 * there (its `??=` trigger/placement defaults), and `PopoverDirective.ngAfterViewInit` wires the trigger from
 * those fields, so the `popover` mode has to be applied in that same hook, after inputs are bound. */
@Directive({
  selector: '[appBoardContextMenu]',
  standalone: true,
})
export class BoardContextMenuDirective extends ContextMenuDirective {
  public readonly appBoardContextMenu = input.required<Board>();
  public readonly appBoardContextMenuMode = input<'contextmenu' | 'popover'>('contextmenu');
  public readonly appBoardContextMenuOpened = outputFromObservable(this.contextMenuOpened);
  public readonly appBoardContextMenuOpenBoard = output<void>();

  public override ngOnInit(): void {
    super.ngOnInit();
    if (this.appBoardContextMenuMode() === 'popover') {
      this.stchPopoverTrigger = 'click';
      this.stchPopoverPlacement = 'bottomLeft';
      this.stchPopoverFallbackPlacements = ['bottomRight'];
    }
  }

  protected registerComponent(): Type<BoardContextMenuComponent> {
    return BoardContextMenuComponent;
  }

  protected registerInstance(componentRef: ComponentRef<BoardContextMenuComponent>): void {
    componentRef.setInput('board', this.appBoardContextMenu());
    outputToObservable(componentRef.instance.open)
      .pipe(takeUntil(this.alive))
      .subscribe(() => this.appBoardContextMenuOpenBoard.emit());
  }
}
